var React = require('react');

function PianoKeyboard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 224v192a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32V224h48v176h480V224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M576 96v128H464v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-80h-80v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-80h-80v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-80H0V96a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

PianoKeyboard.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = PianoKeyboard;

PianoKeyboard.default = PianoKeyboard;
